export default "__VITE_ASSET__By$MNsqj__"